import React from 'react';
import moment from 'moment';
import {Box} from '@mui/material';
import {gridCellDef} from './GridCellDef';

export const renderCellDateTime: gridCellDef<any> = (params) => {
  if (params.value) {
    return (
      <Box flex={1} textAlign="center" alignContent="center" justifyContent="center">
        {moment(params.value?.valueOf() as any).format('DD/MM/YY HH:mma')}
      </Box>
    );
  }
  return <div />;
};
